<template>
  <div class="bg-white rounded p-4 mb-auto">
    <div
      class="relative bg-gray-700 rounded overflow-hidden shadow-lg -mt-8 mb-4"
      style="padding-bottom: 50%"
    >
      <img v-if="hasCover" :src="page.cover.source" class="absolute cover inset-0 w-full h-full" />
    </div>
    <h5 class="text-sm font-normal">
      {{ page.name }}
    </h5>
    <span class="block text-xs text-gray-600 mb-4">{{ page.id }}</span>
    <div class="flex space-x-2">
      <a
        :href="facebookPageUrl"
        class="inline-flex items-center text-white px-3 py-1 text-sm rounded-sm bg-blue-600 hover:bg-blue-700 hover:text-white transition-colors duration-150 focus:outline-none"
        target="_blank"
      >
        View
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  computed: {
    facebookPageUrl() {
      return `https://www.facebook.com/${this.page.id}`;
    },
    hasCover() {
      return typeof this.page?.cover?.source === 'string';
    },
  },
};
</script>
